import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_ADVOCATES_PSF_TASKS = defineFcm('advocates_psf_tasks')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'object',
				shape: {
					id: { type: 'string' },
					label: { type: 'string', optional: true },
					title: { type: 'string' },
					subtitle: { type: 'string', optional: true },
					badgeText: { type: 'string', optional: true },
					badgeHasIcon: { type: 'boolean', optional: true },
				},
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-front-end',
		context: 'Advocates PSF',
		description:
			'Contribution options for the Advocates PSF flow. An option has an id, a label (deprecated, use title instead), a title, a subtitle (optional), a badgeText (optional), and a badgeHasIcon (optional boolean). Any number of options can be added.',
		import: false,
		template: [
			{
				id: 'unique_id',
				title: '',
				subtitle: '',
				badgeText: '',
				badgeHasIcon: false,
			},
		],
	});
